import { defineStore } from "pinia";
import Dashboard from "public/images/dashboard.svg";
import Download from "public/images/download.svg";
import Lists from "public/images/lists.svg";
import Profile from "public/images/profile_panel.svg";
import Support from "public/images/support.svg";
import UserSwap from "public/images/user_swap_panel.svg";
import Wallet from "public/images/wallet.svg";

type HeroItem = {
	id?: number;
	is_series?: boolean;
	is_audio?: boolean;
	image: string;
	name?: string;
	description?: string;
	free?: boolean;
	language?: string;
	accent?: string;
	age_group?: string;
	duration?: string;
	from_year?: string;
	likes?: string;
	views?: string;
	genre?: string | null | undefined;
	genres?: [];
	file_quality?: string;
	link?: string;
};
type SliderItem = {
	id: number;
	title: string;
	description: string;
	image: string;
};
type BlogItem = {
	slug: string;
	title: string;
	short_description: string;
	image: string;
	created_at: string;
	coin_amount?: number;
};
type SeasonItem = {
	zip_id?: number | undefined;
	season_id: string;
	season_name: string;
	animations: AnimationItem[];
};

type AnimationItem = {
	id: number | bigint;
	watchId?: number | undefined;
	is_series?: boolean;
	is_audio?: boolean;
	free?: boolean;
	title: string | null | undefined;
	description?: string | undefined;
	language: string;
	accent: string;
	downloadable?: boolean;
	age_group: string | null | undefined;
	duration: string | null | undefined;
	duration_second?: number | bigint | null | undefined;
	name?: string | null | undefined;
	from_year: string | null | undefined;
	to_year?: string | null | undefined;
	likes: string;
	views?: string;
	cover_file_address?: string | null | undefined;
	animation_season_order_index?: number | bigint | null | undefined;
	file_quality?: string;
	genre?: string | null | undefined;
	size_mega_byte?: string;
	genres?: [];
	image: string;
	liked?: boolean;
	hidden?: boolean;
	animationSeries?: any | null | undefined;
};

type LanguageItem = {
	id: number;
	image: string;
	language: string;
};

type PlaylistItem = {
	id: number;
	name: string;
	count?: number;
	image?: string;
	link?: string;
};

type MostViewedAnimationItem = Partial<AnimationItem>;

type MenuNode = { title: string; uniqueId: string; img?: any };
type MenuStuff = { title: string; uniqueId: string; link: string };
type MenuLeaf = MenuNode & { link: string };
type MenuPath = MenuNode & { submenu: MenuItem[]; isOpen: boolean };
type MenuItem = MenuStuff | MenuLeaf | MenuPath;

export type {
	SeasonItem,
	PlaylistItem,
	MenuNode,
	MenuLeaf,
	MenuPath,
	BlogItem,
	MenuItem,
	SliderItem,
	HeroItem,
	AnimationItem,
	LanguageItem,
	MostViewedAnimationItem,
};
export const useLayoutStore = defineStore("layout", () => {
	const menuItems = ref<MenuItem[]>([
		{
			title: "ویترین",
			uniqueId: "1",
			link: "/",
		},
		{
			title: "دسته‌بندی",
			uniqueId: "2",
			link: "/category",
		},
		{
			title: "گالری من",
			uniqueId: "3",
			link: "/panel/playlists",
		},
		{
			title: "کتابخانه",
			uniqueId: "4",
			link: "/library",
		},
		{
			title: "خدمات‌ما",
			uniqueId: "5",
			link: "/blogs/?tab=3",
		},
	]);

	return { menuItems };
});

export const usePanelLayoutStore = defineStore("panel_layout", () => {
	const panelMenuItems = ref<MenuItem[]>([
		{
			title: "داشبورد",
			uniqueId: "2_1",
			img: shallowRef(Dashboard),
			link: "/panel",
		},
		{
			title: "اطلاعات کاربری",
			img: shallowRef(Profile),
			uniqueId: "2_2",
			link: "/panel/profile",
		},
		{
			title: "تغییر تماشا کننده",
			img: shallowRef(UserSwap),
			uniqueId: "2_3",
			link: "/panel/accounts",
		},
		{
			title: "کیف پول و تراکنش‌ها",
			img: shallowRef(Wallet),
			uniqueId: "2_4",
			link: "/panel/wallet",
		},
		{
			title: "دانلود",
			img: shallowRef(Download),
			uniqueId: "2_5",
			link: "/panel/downloads",
		},
		{
			title: "لیست‌های پخش",
			img: shallowRef(Lists),
			uniqueId: "2_6",
			link: "/panel/playlists",
		},
		{
			title: "پشتیبانی",
			img: shallowRef(Support),
			uniqueId: "2_7",
			link: "/panel/support",
		},
	]);

	return { panelMenuItems };
});

// Hot Module Replacement
if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useLayoutStore, import.meta.hot));
	import.meta.hot.accept(
		acceptHMRUpdate(usePanelLayoutStore, import.meta.hot),
	);
}
